/**
 * PANEL-ASISTENTE-FORMATO-T1: la capa 2 (contexto) y los avisos de incertidumbre de una respuesta de Tu asistente.
 * Una linea discreta a 14px bajo la conclusion; los avisos en ambar. La logica vive en application/asistente.
 */
import { lineaDeContexto } from '../../application/asistente/contextoDeRespuesta.js';

// Deuda 4: era una copia del escape; ahora es el compartido.
import { esc } from './texto.js';

export function contextoRespuestaHTML(c) {
  return `<div data-asistente-contexto style="font-size:14px;color:#8b949e;margin-top:6px">${esc(lineaDeContexto(c))}</div>`
    + (c.avisos.length ? `<div data-asistente-avisos style="font-size:14px;color:#d29922;margin-top:2px">${c.avisos.map(esc).join(' ')}</div>` : '');
}
